import { render, staticRenderFns } from "./RiskProfile.vue?vue&type=template&id=38b2c5fc&scoped=true&"
import script from "./RiskProfile.vue?vue&type=script&lang=js&"
export * from "./RiskProfile.vue?vue&type=script&lang=js&"
import style0 from "./RiskProfile.vue?vue&type=style&index=0&id=38b2c5fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b2c5fc",
  null
  
)

export default component.exports